import api from './api';

class UserService {
    /**
     * Récupère la liste de tous les utilisateurs
     * @returns {Promise<Object>} Liste des utilisateurs
     */
    async getUsers() {
        try {
            const response = await api.users.getAll();
            return response.data;
        } catch (error) {
            console.error('Failed to get users:', error);
            throw error;
        }
    }

    /**
     * Récupère un utilisateur par son ID
     * @param {number} userId - ID de l'utilisateur
     * @returns {Promise<Object>} Données de l'utilisateur
     */
    async getUserById(userId) {
        try {
            const response = await api.users.getById(userId);
            return response.data;
        } catch (error) {
            console.error(`Failed to get user ${userId}:`, error);
            throw error;
        }
    }

    /**
     * Met à jour un utilisateur
     * @param {number} userId - ID de l'utilisateur
     * @param {Object} userData - Données à mettre à jour
     * @returns {Promise<Object>} Utilisateur mis à jour
     */
    async updateUser(userId, userData) {
        try {
            const response = await api.users.update(userId, userData);
            return response.data;
        } catch (error) {
            console.error(`Failed to update user ${userId}:`, error);
            throw error;
        }
    }

    /**
     * Active ou désactive un utilisateur
     * @param {number} userId - ID de l'utilisateur
     * @param {boolean} isActive - Statut actif/inactif
     * @returns {Promise<Object>} Utilisateur mis à jour
     */
    async toggleUserStatus(userId, isActive) {
        try {
            const response = await api.patch(`/users/${userId}/status`, {
                is_active: isActive
            });
            return response.data;
        } catch (error) {
            console.error(`Failed to toggle user ${userId} status:`, error);
            throw error;
        }
    }

    /**
     * Met à jour le rôle d'un utilisateur
     * @param {number} userId - ID de l'utilisateur
     * @param {string} role - Nouveau rôle (USER, ADMIN, SUPER_ADMIN)
     * @returns {Promise<Object>} Utilisateur mis à jour
     */
    async updateUserRole(userId, role) {
        try {
            const response = await api.patch(`/users/${userId}/role`, {
                role: role
            });
            return response.data;
        } catch (error) {
            console.error(`Failed to update user ${userId} role:`, error);
            throw error;
        }
    }

    /**
     * Récupère les paramètres d'un utilisateur
     * @param {number} userId - ID de l'utilisateur
     * @returns {Promise<Object>} Paramètres de l'utilisateur
     */
    async getUserSettings(userId) {
        try {
            const response = await api.users.getSettings(userId);
            return response.data;
        } catch (error) {
            console.error(`Failed to get user ${userId} settings:`, error);
            throw error;
        }
    }

    /**
     * Met à jour les paramètres d'un utilisateur
     * @param {number} userId - ID de l'utilisateur
     * @param {Object} settings - Paramètres à mettre à jour
     * @returns {Promise<Object>} Utilisateur mis à jour avec les nouveaux paramètres
     */
    async updateUserSettings(userId, settings) {
        try {
            const response = await api.users.updateSettings(userId, settings);
            return response.data;
        } catch (error) {
            console.error(`Failed to update user ${userId} settings:`, error);
            throw error;
        }
    }
}

export const userService = new UserService();
export default userService;
